import React from "react";
import DocList from "../../_components/Purchasing/PurchaseDocList";
import { FiFileText, FiClock, FiCheckCircle, FiXCircle, FiUser, FiDollarSign, FiHome } from "react-icons/fi";
import { T, fmtMYR, fmtCurrency } from "../../_components/Purchasing/PurchaseShared";
import {
    getPurchaseCreditNotes,
    getPurchaseCreditNoteKpis,
    deletePurchaseCreditNote
} from "../../_services/finance.service";

export default function PurchaseCreditNotes() {
    return (
        <DocList
            docType="Purchase Credit Note"
            basePath="/finance/purchase-credit-notes"
            fetchList={getPurchaseCreditNotes}
            fetchKpis={getPurchaseCreditNoteKpis}
            deleteItem={deletePurchaseCreditNote}
            statuses={["All", "Draft", "Pending for Approval", "Approved", "Rejected"]}
            kpiCards={[
                { label: "Total", key: "total", icon: FiFileText, color: T.accent },
                { label: "Pending", key: "pending", icon: FiClock, color: T.warning },
                { label: "Approved", key: "approved", icon: FiCheckCircle, color: T.success },
                { label: "Rejected", key: "rejected", icon: FiXCircle, color: T.danger },
            ]}
            previewFields={[
                { icon: FiClock, label: "Date", key: "date" },
                { icon: FiHome, label: "Supplier", key: "supplier" },
                { icon: FiUser, label: "Contact Person", key: "contactPerson" },
                { icon: FiDollarSign, label: "Grand Total", key: "grandTotal", render: (v, row) => fmtCurrency(v, row.currency) },
            ]}
            searchOptions={[
                { key: "all", label: "All" },
                { key: "id", label: "CN No." },
                { key: "date", label: "Date" },
                { key: "supplier", label: "Company Name" },
                { key: "contactPerson", label: "Contact Person" },
            ]}
        />
    );
}